'use client';

import { useEffect, useState } from 'react';
import { usePaginator } from './PaginatorContext';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function PaginatorItemDots({
  activeIndex = 0,
  handleClick = () => {},
  excludeFromIndexes = false,
  item = null,
  className = '',
  children = null,
  label = undefined,
  disabled = false
}) {
  const [isActive, setIsActive] = useState(false);
  const paginator = usePaginator();
  const { dictionary } = useDictionary();
  const ariaLabel =
    label || (!excludeFromIndexes ? `${dictionary?.carousel?.goTo || 'Gå til'} ${activeIndex + 1}` : undefined);

  useEffect(() => {
    if (!item || excludeFromIndexes) return;
    if (paginator.clickDirection === 'forward') {
      if (
        (paginator.index < 2 && paginator.index === item.index) ||
        (item.index === 2 && paginator.index >= 2 && paginator.index < paginator.items.length - 2) ||
        (item.index === 3 && paginator.index >= paginator.items.length - 2)
      ) {
        paginator.setActiveIndex(item.index);
      }
    }

    if (paginator.clickDirection === 'backward') {
      if (
        (item.index >= 2 && item.index === paginator.index - (paginator.items.length - 1) + 3) ||
        (item.index === 1 && paginator.index >= 1 && paginator.index < paginator.items.length - 2) ||
        (item.index === 0 && item.index === paginator.index)
      ) {
        paginator.setActiveIndex(item.index);
      }
    }
  }, [paginator.index]);

  useEffect(() => {
    if (excludeFromIndexes) return;
    setIsActive(activeIndex === paginator.activeIndex);
  }, [paginator.activeIndex]);

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={ariaLabel}
      aria-current={isActive ? 'true' : undefined}
      aria-disabled={disabled || undefined}
      className={`Paginator__item ${isActive ? 'Paginator__item--active' : ''} ${className}`}
    >
      {children && children}
    </button>
  );
}
